<!-- <button (click)="changeBackround('white')">white</button> -->
<!-- <div>
  <span style="background-color: gray; cursor: pointer;" (click)="changeBackround('gray')">
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span> &nbsp;
  <span style="background-color: white;cursor: pointer;" (click)="changeBackround('white')">
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span> &nbsp;
  <span style="background-color: black; cursor: pointer;" (click)="changeBackround('black')">
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span> &nbsp;
</div> -->

<div>
  <!-- <div id="overlay" *ngIf="loader">
    <div class="loader">
      <sh-spinner label="Loading"></sh-spinner>
    </div>
  </div> -->
  <div id="overlay" *ngIf="loader">
    <div class="loader" *ngIf="!httpService.previewDuringUpload">
      <sh-progress-radial size="l" value="{{uploadPercentDone}}" label="{{uploadPercentDone}}%">
      </sh-progress-radial>
      <b class="warning">{{ uploadText }}</b>
      <!--  -->
    </div>
    <div class="loader" *ngIf="httpService.previewDuringUpload">
      <sh-progress-radial size="l" value="100" label = "100%">
      </sh-progress-radial>
      <b class="warning">Rendering</b>
      <sh-icon class="cancel-icon" icon="cancel" (click) = "loader = false;"></sh-icon>
      <!--  -->
    </div>
  </div>
  <div class="renderer-container" #rendererContainer>
    <sh-icon icon="fullscreen" button (click)="makeFullScreen()" id="fullscreen"></sh-icon>
      <sh-tooltip label="FullScreen" target="fullscreen" placement="top" variation="short"></sh-tooltip>
    <sh-icon icon="csi-matrix-scan" button (click)="closeCanvas()" id="gallery"></sh-icon>
      <sh-tooltip label="Gallery Mode" target="gallery"placement="top" variation="short"></sh-tooltip>
    <!-- <button (click)="makeFullScreen()" style="position: absolute; bottom: 10px; right: 20px;">full</button> -->
  </div>

</div>
<br>